import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';

const toolName = 'get-html-from-query-selectors' as const;

const argumentZod = z.object({
  selectors: z.array(z.string()).max(5).describe(dedent`
    CSS selectors to search for in the HTML (max 5). 
    `),
});

export const getHtmlFromQuerySelectorsTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Check elements using search',
  prettyStatus: {
    executing: 'Checking elements using search...',
    executed: 'Checked elements using search',
    failed: 'Failed to check elements using search',
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Returns the HTML sections matching given CSS selectors on the current page. Use to inspect element structure and class usage. Returns data-w-id attributes for use with other element tools.

      Reuse this result only while no page-mutating tool or external action has changed the page. After a successful mutation or STALE_CONTEXT response, re-read before using element IDs or markup from an earlier result.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SitePage', action: 'editContent'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
  timeout: 30000, // 30 seconds for removing style property
  compaction: {
    prompt:
      'Summarize the queried HTML results. Preserve element data-w-ids, CSS class names, matched selectors, and structural context. Remove raw HTML tags and repetitive markup.',
    staleAfterTurns: 3,
  },
});
